import React, { FC } from "react";
import { OidcLogout } from "./oidc/OidcLogout";

export const Logout: FC = () => {
  return <OidcLogout />;
};
